import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function categoryUserReducer(
  state = initialState.categoriesUser,
  action
) {
  if (action.type === types.LOAD_REPORT_CATEGORY_DATA_USER_SUCCESS) {
    return action.categoriesUser;
  }

  return state;
}

